import { useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";
import { membershipPlans } from "../data/membershipPlans";

function Membership() {
  const navigate = useNavigate();
  const { membership, setMembership } = useCart();

  const selectPlan = (plan) => {
    setMembership(plan);
    alert(`${plan.name} membership selected`);
  };

  return (
    <div
      style={{
        padding: "40px",
        fontFamily: "Arial, sans-serif",
        maxWidth: "1100px",
        margin: "0 auto",
        background: "#000",
        color: "#fff",
        minHeight: "100vh",
      }}
    >
      <button onClick={() => navigate("/")} style={btn}>
        Back to Home
      </button>

      <h1 style={{ marginBottom: "10px" }}>MistriBazaar Membership</h1>
      <p style={{ lineHeight: "1.8", color: "#d1d1d1", maxWidth: "900px" }}>
        Membership is designed for customers who expect repeated construction,
        repair, labour, inspection, or material-related orders. The main goal is
        to give better booking priority, better pricing support, and a smoother
        repeat-order experience.
      </p>

      <div style={infoBox}>
        <h3 style={{ marginTop: 0 }}>Membership Benefits Explained Clearly</h3>
        <ul style={{ lineHeight: "1.9", paddingLeft: "20px", marginBottom: 0 }}>
          <li>Priority in booking queue compared to non-members</li>
          <li>10% cashback on eligible completed orders, regardless of plan</li>
          <li>Better pricing stability during high-demand periods</li>
          <li>Access to member-only promo codes</li>
          <li>Better repeat-order value over time</li>
        </ul>
      </div>

      {membership && (
        <div style={{ ...card, marginTop: "24px" }}>
          <h3 style={{ marginTop: 0, color: "#fff" }}>Current Membership</h3>
          <p style={{ color: "#d1d1d1" }}>
            <strong>{membership.name}</strong> • {membership.duration}
          </p>
          <p style={{ color: "#d1d1d1" }}>
            Your membership is active in cart and checkout pricing calculations.
          </p>
        </div>
      )}

      <div style={{ display: "grid", gap: "18px", marginTop: "24px" }}>
        {membershipPlans.map((plan) => (
          <div key={plan.name} style={card}>
            <h3 style={{ marginTop: 0, color: "#fff" }}>{plan.name}</h3>

            <p style={{ color: "#d1d1d1" }}>
              <strong>Tenure:</strong> {plan.duration}
            </p>

            <p style={{ color: "#d1d1d1" }}>
              <strong>Membership Price:</strong> ₹{plan.upfrontPrice}
            </p>

            <div style={benefitBox}>
              <strong style={{ color: "#fff" }}>Included Benefits</strong>
              <ul style={{ marginTop: "10px", paddingLeft: "18px", color: "#d1d1d1", lineHeight: "1.8" }}>
                {plan.benefits.map((benefit) => (
                  <li key={benefit}>{benefit}</li>
                ))}
              </ul>
            </div>

            <button onClick={() => selectPlan(plan)} style={solidBtn}>
              Choose Plan
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

const btn = {
  marginBottom: "20px",
  padding: "10px 16px",
  border: "1px solid #444",
  background: "#111",
  color: "white",
  borderRadius: "8px",
  cursor: "pointer",
};

const infoBox = {
  marginTop: "24px",
  background: "#111",
  border: "1px solid #2a2a2a",
  padding: "22px",
  borderRadius: "14px",
};

const card = {
  background: "#111",
  padding: "22px",
  borderRadius: "14px",
  boxShadow: "0 3px 12px rgba(0,0,0,0.25)",
  border: "1px solid #2a2a2a",
};

const benefitBox = {
  background: "#0b0b0b",
  border: "1px solid #232323",
  padding: "16px",
  borderRadius: "12px",
  marginBottom: "16px",
};

const solidBtn = {
  padding: "12px 18px",
  border: "none",
  background: "white",
  color: "black",
  borderRadius: "8px",
  cursor: "pointer",
  fontWeight: "bold",
};

export default Membership;
